import styled from 'styled-components';

export const CartChannelsWrapper = styled.div`
    height: 1.5rem;
`;
